module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Nazare-37e7659f4ef5f012dd35dedf6c08b2ea.jpg";